import type { FC } from 'react';

import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { useTimeLeft } from '@wwe-portal/ui/lib/hooks';
import { cn } from '@wwe-portal/ui/lib/lib';

interface TimeLeftCountdownProps {
  endDate: string;
  iconSize?: number;
  showText?: boolean;
  className?: string;
}

export const TimeLeftCountdown: FC<TimeLeftCountdownProps> = ({
  endDate,
  iconSize = 12,
  showText = true,
  className,
}) => {
  const { ended, getTimeText } = useTimeLeft(endDate);
  if (ended) return null;
  return (
    <div
      className={cn(
        'flex items-baseline stroke-2 text-center font-bold text-white',
        className
      )}
    >
      {showText && <span style={{ margin: 'auto 0px' }}>ENDS IN: </span>}
      <div className="-mt-[5px] px-[5px]">
        <IcoMoonIcon
          iconName="timer"
          style={{
            width: iconSize,
            height: iconSize,
          }}
        />
      </div>
      <div
        className="font-akagi text-left font-semibold uppercase text-white"
        style={{ margin: 'auto 0px' }}
      >
        {getTimeText()}
      </div>
    </div>
  );
};
